var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
import styled from 'styled-components';
import { BORDER_RADIUS_PX } from '../constants';
import { NamedColorsHEX } from '../constants';
export var ButtonColorSchema;
(function (ButtonColorSchema) {
    ButtonColorSchema["primary"] = "primary";
    ButtonColorSchema["default"] = "default";
    ButtonColorSchema["outline"] = "outline";
})(ButtonColorSchema || (ButtonColorSchema = {}));
var buttonColorSchema = {
    default: {
        backgroundColor: NamedColorsHEX.LightSlateGray,
        borderColor: NamedColorsHEX.LightSlateGray,
    },
    primary: {
        backgroundColor: NamedColorsHEX.SandyBrown,
        borderColor: NamedColorsHEX.SandyBrown,
    },
    outline: {
        backgroundColor: 'white',
        borderColor: NamedColorsHEX.LightSlateGray,
    },
};
export var Button = styled.button(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  background-color: ", ";\n  margin: 5px 0;\n  height: ", ";\n  border: 2px solid black;\n  border-color: ", ";\n  border-radius: ", "px;\n  color: black;\n  touch-action: manipulation;\n\n  :hover {\n    cursor: ", ";\n  }\n\n  :active {\n    background-color: #ccc;\n  }\n\n  :disabled {\n    background-color: ", "32;\n    border-color: ", "32;\n  }\n"], ["\n  background-color: ",
    ";\n  margin: 5px 0;\n  height: ", ";\n  border: 2px solid black;\n  border-color: ",
    ";\n  border-radius: ", "px;\n  color: black;\n  touch-action: manipulation;\n\n  :hover {\n    cursor: ", ";\n  }\n\n  :active {\n    background-color: #ccc;\n  }\n\n  :disabled {\n    background-color: ",
    "32;\n    border-color: ",
    "32;\n  }\n"])), function (props) {
    return buttonColorSchema[props.colorSchema || ButtonColorSchema.default]
        .backgroundColor;
}, function (props) { return (props.compact ? '35px' : '45px'); }, function (props) {
    return buttonColorSchema[props.colorSchema || ButtonColorSchema.default]
        .borderColor;
}, BORDER_RADIUS_PX, function (props) { return (props.pointerCursor ? 'pointer' : 'initial'); }, function (props) {
    return buttonColorSchema[props.colorSchema || ButtonColorSchema.default]
        .backgroundColor;
}, function (props) {
    return buttonColorSchema[props.colorSchema || ButtonColorSchema.default]
        .borderColor;
});
var templateObject_1;
//# sourceMappingURL=Button.js.map